import { React, Component, _ } from 'utils';
import './resumes.less';

export default class PageCount extends Component {

	constructor(props)
	{
		super(props);
	}
	render() {
		var { count, onClick } = this.props;

		return <div className="dropdown pager-drop">
			<button className="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
				{_('Prikaz po stranici') + ' ( ' + count + ' ) '}
			</button>
			<div className="dropdown-menu box-width" aria-labelledby="dropdownMenu1">
				<button className={(count == '20')? 'btn pager-btn selected':'btn pager-btn'} value='20' onClick={onClick} >20</button>
				<button className={(count == '100')? 'btn pager-btn selected':'btn pager-btn'} value='100' onClick={onClick} >100</button>
				<button className={(count == '300')? 'btn pager-btn selected':'btn pager-btn'} value='300' onClick={onClick} >300</button>
			</div>
		</div>
	}
}



// WEBPACK FOOTER //
// ./src/modules/app/resumes/PageCount.js